<template>
  <div class="wraper" >
    <div class="layer"></div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Vessel',
  props: {
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
.wraper {
  position: relative;
}
.highlight .layer {
  display: block;
}
.layer {
  box-sizing: border-box;
  // display: none;
  width: 100%;
  height: 100%;
  position: absolute;
  border: 2px #f9fe25 solid;
  position: absolute;
  top: 0;
  left: 0;
  box-shadow: 0px 0px 12px 6px rgba(255, 201, 38, 0.65);
  pointer-events: none;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-shadow: 0px 0px 12px 6px rgba(255, 201, 38, 0.65) inset;
    background-color: rgba(255, 201, 38, 0.15);
  }
}
</style>
